import Http from "@services/http";
import BaseApi from "@api/base.api";

export default class ProjectsApi extends BaseApi {
    static get entity() {
        return "projects";
    }

    static async getByIds(params = {}) {
        return await Http.get("projects/bulk", params);
    }

    static async getProjectsStatus(params = {}) {
        return await Http.get("projects/status", params);
    }

    // Delete a project with its documents
    static async delete(payload = {}) {
        return await Http.delete(`projects/${payload.id}`, { data: payload });
    }
    
    // Bulk delete multiple projects with their documents
    static async bulkDelete(payload = {}) {
        return await Http.post(`projects-bulk-delete`, payload);
    }

    // Team management
    static async mutateMember(projectId, payload = {}) {
        // Unified endpoint: action in payload determines behavior (replace vs roll-off)
        // payload: { from_member_id|assignment_id, effective_date, reason?, replacement_user_id?, replacement_start_date?, action?: 'replace'|'rolloff' }
        return await Http.post(`projects/${projectId}/team/roll-off`, payload).then(r => r.data);
    }

      // Setup Codification
      static async setupCodification(projectId, payload = {}) {
        return await Http.post(`projects/${projectId}/setup-codification`, payload);
      }

      // Get documents by business units
      static async getDocumentsByBusinessUnits(projectId, payload = {}) {
        return await Http.post(`projects/${projectId}/documents/by-business-units`, payload);
      }

      // Handle document actions for business unit changes
      static async handleDocumentBUChange(projectId, payload = {}) {
        return await Http.post(`projects/${projectId}/documents/handle-bu-change`, payload);
      }
}
